import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { FormattedMessage } from 'sb-react-intl'
import { links, constants, snowplow, formatPrice } from 'common/helpers'

import { Button, buttonMessages } from 'components/_new/controls'

import messages from './messages'
import s from './SubscribeTodayForJust.scss'


const SubscribeTodayForJust = ({ isLoggedIn, id }) => {
  const { subscriptionPrice } = useConnect({
    subscriptionPrice: (state) => formatPrice(state.models.subscription.price, true),
  })

  const handleClick = useCallback(() => {
    snowplow.track(constants.snowplowEvents.subscribeNowLinkClick, {
      placement: 'sidebar',
    }, false)
  }, [])

  return (
    <aside className={s.section}>
      <FormattedMessage tag="p" {...messages.subscribeTodayForJust} values={{ subscriptionPrice }} />
      <Button
        id={id || 'subscribeButton'}
        title={buttonMessages.subscribeNow}
        color="brand"
        size="md"
        to={isLoggedIn ? links.subscribe : links.register}
        fullWidth
        dataTestId="subscribeNowButton"
        onClick={handleClick}
      />
    </aside>
  )
}

SubscribeTodayForJust.propTypes = {
  isLoggedIn: PropTypes.bool,
}


export default SubscribeTodayForJust
